import { Link } from 'react-router-dom';

const steps = [
  {
    step: '01',
    icon: 'ri-global-line',
    title: '打开浏览器',
    desc: '在电脑或手机浏览器地址栏中输入蘑菇视频网页版网址，进入首页。支持Chrome、Edge、Safari等主流浏览器。',
  },
  {
    step: '02',
    icon: 'ri-search-line',
    title: '搜索或浏览',
    desc: '在首页搜索框输入想看的视频名称，或者通过分类导航浏览电视剧、电影、综艺等丰富内容。',
  },
  {
    step: '03',
    icon: 'ri-play-circle-line',
    title: '点击播放',
    desc: '点击视频封面即可进入播放页面，系统自动匹配最佳清晰度，即点即看不等待。',
  },
  {
    step: '04',
    icon: 'ri-heart-line',
    title: '收藏分享',
    desc: '登录后可以收藏喜欢的视频、同步观看进度，还能把精彩内容分享给好友一起观看。',
  },
];

export default function GuideSection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            如何使用蘑菇视频网页版
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            四步轻松上手，立即开始您的在线观影之旅
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div
              key={step.step}
              className="relative flex flex-col items-center text-center p-6"
            >
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[60%] w-full h-px bg-accent-200 z-0"></div>
              )}
              <div className="relative z-10 w-16 h-16 flex items-center justify-center rounded-2xl bg-accent-100 mb-5">
                <i className={`${step.icon} text-2xl text-accent-600`}></i>
              </div>
              <div className="text-xs font-bold text-accent-500 mb-2 font-label">步骤 {step.step}</div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{step.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <Link
            to="/article/mogu-video-web-version-access-guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            查看详细使用指南
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}